import React from 'react';
import PropTypes from 'prop-types';

export default function ScheduleTypeToggle({ value, onChange, disabled }) {
  return (
    <div className="schedule-type-toggle" role="group" aria-label="Shift or event">
      <button
        type="button"
        className={!value ? 'is-selected' : undefined}
        aria-pressed={!value}
        disabled={disabled}
        onClick={() => onChange(false)}
      >
        Shift
      </button>
      <button
        type="button"
        className={value ? 'is-selected' : undefined}
        aria-pressed={!!value}
        disabled={disabled}
        onClick={() => onChange(true)}
      >
        Event
      </button>
    </div>
  );
}

ScheduleTypeToggle.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ScheduleTypeToggle.defaultProps = {
  value: false,
  disabled: false,
};
